// import React from "react";
// import Chart from "react-apexcharts";
// import dummyData from '../data.json';

// const StaffAvailabilityChart = () => {
//   // Convert time to 24-hour format (minutes from midnight)
//   const convertTo24Hour = (time) => {
//     if (!time || typeof time !== "string") return null; // Prevent errors

//     let [hours, minutes] = time.trim().split(/[: ]/);
//     const isPM = time.includes("PM");

//     hours = parseInt(hours, 10);
//     minutes = parseInt(minutes, 10) || 0; // Default to 0 if missing

//     if (isNaN(hours) || isNaN(minutes)) return null;

//     if (isPM && hours !== 12) hours += 12;
//     if (!isPM && hours === 12) hours = 0;

//     return hours * 60 + minutes; // Convert to total minutes from midnight
//   };

//   // Function to format minutes into "HH:MM AM/PM"
//   const formatTime = (minutes) => {
//     if (minutes === null || isNaN(minutes)) return ""; // Handle invalid cases

//     const hours = Math.floor(minutes / 60);
//     const mins = minutes % 60;
//     const ampm = hours >= 12 ? "PM" : "AM";
//     const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
//     return `${formattedHours}:${mins.toString().padStart(2, "0")} ${ampm}`;
//   };

//   // Extract unique zones (for Y-axis labels)
//   const zones = dummyData.staffAvailable.zones.map((zone) => zone.zone);

//   // Allowed staff categories
//   const allowedCategories = ["CSA", "DM", "SM", "Cleaning Staff"];

//   // Prepare data for ApexCharts
//   const series = [];
//   const categoryMap = {};

//   dummyData.staffAvailable.zones.forEach((zone) => {
//     zone.staff.forEach((staff) => {
//       if (allowedCategories.includes(staff.category)) { // Filter staff categories
//         const startTime = convertTo24Hour(staff.available_from);
//         const endTime = convertTo24Hour(staff.available_to);

//         if (startTime !== null && endTime !== null) { // Ensure valid time
//           if (!categoryMap[staff.category]) {
//             categoryMap[staff.category] = [];
//           }
//           categoryMap[staff.category].push({
//             x: zone.zone, // Zones on Y-axis
//             y: [startTime, endTime]
//           });
//         }
//       }
//     });
//   });

//   for (const category in categoryMap) {
//     series.push({
//       name: category, // Staff categories
//       data: categoryMap[category] // Each bar shows zone-wise availability
//     });
//   }

//   const options = {
//     chart: {
//       type: "rangeBar",
//       height: 400,
//       toolbar: { show: false }
//     },
//     plotOptions: {
//       bar: {
//         horizontal: true,
//         barHeight: "80%",
//         borderRadius: 4
//       }
//     },
//     fill: {
//       type: 'solid',
//       opacity: 0.8
//     },
//     xaxis: {
//       type: "numeric",
//       title: { text: "Time" },
//       labels: {
//         formatter: formatTime // ✅ Fixing X-axis labels
//       }
//     },
//     yaxis: {
//       title: { text: "Zones" },
//       categories: zones
//     },
//     tooltip: {
//       y: {
//         formatter: (value) => {
//           if (Array.isArray(value) && value.length === 2) {
//             return `${formatTime(value[0])} - ${formatTime(value[1])}`; // ✅ Fixing Tooltip Format
//           }
//           return formatTime(value);
//         }
//       }
//     },
//     legend: {
//       position: "top"
//     },
//     colors: ["#5FA8D3", "#69B0AC", "#75C9B7", "#81D4A3"]
//     // Muted Analogous Colors: Muted Teal, Steel Blue, Soft Aqua, Cool Mint
//   };

//   return (
//     <div>
//       <Chart options={options} series={series} type="rangeBar" height={400} />
//     </div>
//   );
// };

// export default StaffAvailabilityChart;

import { getZonalStaffPresence } from 'api';
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';

// import { useSelector } from "react-redux"; // Import Redux hook

const StaffAvailabilityChart = () => {
  const [chartData, setChartData] = useState([]);
  const [zones, setZones] = useState([]);

  // Get selectedDate from Redux store
  // const selectedDate = useSelector((state) => state.date.selectedDate);
  const date = useSelector((state) => state.customization.currentDate);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  const formattedDate = formatDate(date);

  // Convert time to 24-hour format (minutes from midnight)
  const convertTo24Hour = (time) => {
    if (!time || typeof time !== 'string') return null;
    let [hours, minutes] = time.trim().split(':').map(Number);
    return hours * 60 + minutes;
  };

  // Function to format minutes into "HH:MM AM/PM"
  const formatTime = (minutes) => {
    if (minutes === null || isNaN(minutes)) return '';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${formattedHours}:${mins.toString().padStart(2, '0')} ${ampm}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!formattedDate) return; // Ensure date is available before calling API

        const requestData = { date: formattedDate, source_id: 'dombivli' };
        const response = await getZonalStaffPresence(requestData);

        if (response?.data?.data) {
          const apiData = response.data.data[0]?.staffAvailable || [];
          const formattedZones = [];
          const seriesData = [];

          apiData.forEach((zoneItem) => {
            const { zone, staff } = zoneItem.zones;
            if (zone && staff.length > 0) {
              formattedZones.push(zone);
              staff.forEach(({ available_from, available_to }) => {
                const startTime = convertTo24Hour(available_from);
                const endTime = convertTo24Hour(available_to);

                if (startTime !== null && endTime !== null) {
                  seriesData.push({
                    x: zone,
                    y: [startTime, endTime]
                  });
                }
              });
            }
          });

          setZones(formattedZones);
          setChartData([{ name: 'Staff Availability', data: seriesData }]);
        }
      } catch (error) {
        console.error('Error fetching staff availability data:', error);
      }
    };

    fetchData();
  }, [formattedDate]); // Fetch data when selectedDate changes

  const options = {
    chart: { type: 'rangeBar', height: 400, toolbar: { show: false } },
    plotOptions: { bar: { horizontal: true, barHeight: '80%', borderRadius: 4 } },
    fill: { type: 'solid', opacity: 0.8 },
    xaxis: { type: 'numeric', title: { text: 'Time' }, labels: { formatter: formatTime } },
    yaxis: { title: { text: 'Zones' }, categories: zones },
    tooltip: {
      y: { formatter: (value) => (Array.isArray(value) ? `${formatTime(value[0])} - ${formatTime(value[1])}` : formatTime(value)) }
    },
    legend: { position: 'top' },
    colors: ['#44BE54']
  };

  return <Chart options={options} series={chartData} type="rangeBar" height={400} />;
};

export default StaffAvailabilityChart;
